<template>
  <div>
    <!-- table principal -->
    <el-row>
      <el-col>
        <!-- <h1>KPI Cumplimiento SLA</h1> -->
        <yearcomponent
          ref="yearC"
          @change="handler_year"
          v-model="year"
        ></yearcomponent>

        <el-select
          v-model="product"
          @change="handlerChangesProduct"
          size="mini"
          clearable
          placeholder="Productos"
          class="ml-5"
        >
          <el-option
            v-for="item in list_products"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        <el-select
          v-model="serviceTypeID"
          @change="handlerChangesServices"
          size="mini"
          clearable
          placeholder="Tipo de servicio"
          class="ml-5"
        >
          <el-option
            v-for="item in list_types_to_select"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <DirectionSelector @selection-change="handleChangeDirection" />
        <el-select
          v-model="employeeStatus"
          @change="handlerChangesEmployeeStatus"
          size="mini"
          clearable
          placeholder="Estado de empleado"
          class="ml-5"
        >
          <el-option
            v-for="item in typeEmployeeStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-row>
      <el-col>
        <rabbey-table2
          :columns="columns2"
          :show-summary="true"
          :summary-method="getTotalByMonthSLA"
          :default-items="technicalTracker"
          :paginateFromApi="false"
          v-loading="principalTable"
        />
      </el-col>
    </el-row>

    <!-- table detalle por Vendedor -->
    <DetailTechnicalSupportKpi ref="details" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import yearcomponent from "@/components/Global_System/YearsComponent.vue";
import { Months, commentColumns } from "@/helpers/TechnicalSupportColumns";
import { getTotalByMonthSLA } from "@/helpers/TableRabbeyTools";
import DetailTechnicalSupportKpi from "./DetailTechnicalSupportKpi.vue";
import { formatArrayToElSelect } from "@/utils";
import DirectionSelector from "@/components/Company/DirectionSelector.vue";

export default {
  name: "KpiSoporteTecnico",
  components: {
    DetailTechnicalSupportKpi,
    yearcomponent,
    DirectionSelector
  },
  data() {
    return {
      principalTable: true,
      loadingDetails: true,
      deals: false,
      formpayment: false,
      year: new Date().getFullYear(),
      value: "",
      TypeAgent: "customerservice",
      directionId: 0,
      employeeStatus: "",
      typeServices: [],
      types: [
        { value: 0, label: "Todos los Productos" },
        { value: 2, label: "MagyTrack" },
        { value: 14, label: "TPD" },
        { value: 15, label: "NCF Movil" },
        { value: 16, label: "SeaHorse" },
        { value: 17, label: "MagyPago" },
        { value: 18, label: "Magylottery" }
      ],
      typeEmployeeStatus: [
        { value: "", label: "Todos" },
        { value: "ACT", label: "Activos" },
        { value: "INA", label: "Inactivos" }
      ],
      SellerName: "",
      contacts: [],
      loadingContacts: false,
      month: "",
      MontlyTarget: "",
      AccountNumber: "",
      serviceTypeID: 0,
      product: 0,
      InvoiceNum: "",
      ContactEmail: "",
      ProductList: [],
      form: {
        currentdate: "",
        newdate: "",
        comment: "",
        contactCode: ""
      },
      columns: [
        {
          prop: "tecnico",
          name: "Tecnico",
          minWidth: 220,
          fixed: true
        },
        ...Months
      ],
      columns2: [
        {
          prop: "technical",
          name: "Tecnico",
          minWidth: 220,
          fixed: true
        },
        ...this.mapOb(Months)
      ],
      columnsComments: [...commentColumns],
      items: [],
      comments: [],
      Dcoments: false,
      commentloading: false,
      slaTracker: {
        Failed: 0,
        Compliment: 1
      },
      technicalTracker: []
    };
  },
  mounted() {
    this.$refs.yearC.Year = this.year;
  },
  created() {
    this.getData();
    this.$store.dispatch("request_types/all");
    this.$store.dispatch("products/all");

    this.$http
      .get("/api/KpiTechnicalSupport/getTypeServicesSLA", {
        params: { companyId: this.currentCompany }
      })
      .then(({ data }) => {
        this.typeServices = this.formatArrayToElSelect(data, {
          value: "Id",
          label: "Description"
        });
        this.typeServices.unshift({ value: 0, label: "Todos los Servicios" });
      });
  },
  watch: {
    list_products() {
      this.list_products.unshift({ value: 0, label: "Todos los Productos" });
    },
    list_types_to_select() {
      this.list_types_to_select.unshift({
        value: 0,
        label: "Todos los Servicios"
      });
    }
  },
  computed: {
    ...mapGetters({
      list_types_to_select: "request_types/list_to_select",
      list_products: "products/list_products"
    }),
    isValid: function () {
      return this.form.comment.trim().length > 5 && this.form.newdate !== null;
    },
    groupItems() {
      return this._.groupBy(this.items, "tecnico");
    }
  },
  methods: {
    getTotalByMonthSLA,
    formatArrayToElSelect,
    getPorcentajeByUserAndMonth(month, techinicalName, year) {
      const KpiTechnicalSupport = this.groupItems[techinicalName];
      if (KpiTechnicalSupport === undefined) {
        return 0;
      }

      let countCompliment = 0;
      let countFailed = 0;
      for (let index = 0; index < KpiTechnicalSupport.length; index++) {
        const element = KpiTechnicalSupport[index];
        const createdAt = this.$moment(
          element.CreatedAt,
          "YYYY-MM-DDTHH:mm:ss.SSS"
        );
        const elementMonth = createdAt.format("M");
        const elementYear = createdAt.format("YYYY");

        if (
          month === elementMonth &&
          year === elementYear &&
          element.SLA === this.slaTracker.Compliment
        ) {
          countCompliment++;
        }

        if (
          month === elementMonth &&
          year === elementYear &&
          element.SLA === this.slaTracker.Failed
        ) {
          countFailed++;
        }
      }

      const suma = countCompliment + countFailed;
      let Porcentaje = suma > 0 ? (countCompliment / suma) * 100 : 0;

      return Porcentaje;
    },
    openDetail(mes, row) {
      this.$refs.details.show(row, mes, this.year);
    },
    getProductSelected() {
      return this.product;
    },
    getServiceTypeSelected() {
      return this.serviceTypeID;
    },
    mapOb(data) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        element.cellAtrrs = {
          getProductSelected: this.getProductSelected,
          getServiceTypeSelected: this.getServiceTypeSelected,
          openDetail: this.openDetail,
          ...element.cellAtrrs
        };
      }
      return data;
    },
    handler_year(_year) {
      this.year = _year;
      this.getData();
    },
    handlerChangesProduct(_Product) {
      this.product = _Product;
      this.getData();
    },
    handlerChangesServices(_Service) {
      this.serviceTypeID = _Service;
      this.getData();
    },
    handleChangeDirection(directionId) {
      this.directionId = directionId;
      this.getData();
    },
    handlerChangesEmployeeStatus(employeeStatus) {
      this.employeeStatus = employeeStatus;
      this.getData();
    },
    handleClose() {
      this.form.currentdate = "";
      this.form.newdate = "";
      this.form.comment = "";
      this.form.contactCode = "";
      this.AccountNumber = "";
      this.InvoiceNum = "";
      this.ContactEmail = "";
    },
    getData() {
      let params = {
        year: this.year,
        companyID: this.currentCompany,
        product: this.product,
        serviceTypeID: this.serviceTypeID,
        directionId: this.directionId,
        employeeStatus: this.employeeStatus
        //serviceTypeID: serviceTypeID
        //product: product
      };
      this.$store.commit("rabbey_table/loading");
      this.$http
        .get("/api/KpiTechnicalSupport/GetKpiSupport", {
          params: params
        })
        .then(({ data }) => {
          this.items = data;
          this.$store.commit("rabbey_table/items", data);

          const technicalsGroup = this._.groupBy(data, "tecnico");

          let t = {};
          this.technicalTracker = [];
          const technicals = Object.keys(technicalsGroup);

          for (let index = 0; index < technicals.length; index++) {
            const techinicalName = technicals[index];

            t = {
              technicalId: 0,
              technical: techinicalName,
              1: 0,
              2: 0,
              3: 0,
              4: 0,
              5: 0,
              6: 0,
              7: 0,
              8: 0,
              9: 0,
              10: 0,
              11: 0,
              12: 0,
              total: 0
            };

            const solicitudes = technicalsGroup[techinicalName];
            const primeraSolicitud = solicitudes[0];
            const createdAt = this.$moment(
              primeraSolicitud.CreatedAt,
              "YYYY-MM-DDTHH:mm:ss.SSS"
            );
            const year = parseInt(createdAt.format("YYYY"));
            t.technicalId = primeraSolicitud.tecnicoID;

            let monthTracker = {
              1: {
                Compliment: 0,
                Failed: 0
              },
              2: {
                Compliment: 0,
                Failed: 0
              },
              3: {
                Compliment: 0,
                Failed: 0
              },
              4: {
                Compliment: 0,
                Failed: 0
              },
              5: {
                Compliment: 0,
                Failed: 0
              },
              6: {
                Compliment: 0,
                Failed: 0
              },
              7: {
                Compliment: 0,
                Failed: 0
              },
              8: {
                Compliment: 0,
                Failed: 0
              },
              9: {
                Compliment: 0,
                Failed: 0
              },
              10: {
                Compliment: 0,
                Failed: 0
              },
              11: {
                Compliment: 0,
                Failed: 0
              },
              12: {
                Compliment: 0,
                Failed: 0
              }
            };

            for (let index = 0; index < solicitudes.length; index++) {
              const solicitud = solicitudes[index];
              const createdAt = this.$moment(
                solicitud.CreatedAt,
                "YYYY-MM-DDTHH:mm:ss.SSS"
              );
              const elementMonth = parseInt(createdAt.format("M"));
              const elementYear = parseInt(createdAt.format("YYYY"));

              for (let month = 1; month < 13; month++) {
                if (month === elementMonth && year === elementYear) {
                  if (solicitud.SLA === this.slaTracker.Compliment) {
                    monthTracker[month].Compliment++;
                  } else if (solicitud.SLA === this.slaTracker.Failed) {
                    monthTracker[month].Failed++;
                  }
                }
              }
            }

            let c = 0;
            let f = 0;
            for (let month = 1; month < 13; month++) {
              const { Compliment, Failed } = monthTracker[month];
              c += Compliment;
              f += Failed;
              const sum = Compliment + Failed;
              t[`${month}`] = sum > 0 ? (Compliment / sum) * 100 : 0;
            }

            const sumTotal = c + f;
            t.total = sumTotal > 0 ? (c / sumTotal) * 100 : 0;

            this.technicalTracker.push(t);
          }
        })
        .finally(() => {
          this.$store.commit("rabbey_table/success");
          this.principalTable = false;
        });
    },
    getProductbySLA() {
      this.$http
        .get("/api/KpiTechnicalSupport/getProductbySLASupport", {
          params: {
            companyId: this.company
          }
        })
        .then((resp) => {
          this.ProductList = resp.data;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    getTypeServices() {
      this.$http
        .get("/api/KpiTechnicalSupport/getTypeServicesSLA", {
          params: {
            companyId: this.company
          }
        })
        .then((resp) => {
          this.TypeService = resp.data;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    }
  }
};
</script>

<style>
#table-card td {
  padding-left: 10px;
}
.col-p {
  padding: 0 10px;
  box-sizing: border-box;
}
</style>
